export default "__VITE_ASSET__e6185970__"